import { PageTemplate } from '@/shared/ui/templates';
import styles from './index.module.sass';
import { OfferContractItem } from '../../components/offer-contract-item/index.component';
import {
  $approvedTradesGroups,
  $approvedTradesGroupsLoadingStatus,
  fetchApprovedTradesGroupsListFx,
} from '../../store/business-offers.store';
import { useEffect } from 'react';
import { useStore } from 'effector-react';
import { UniversalLoader } from '@/modules/common/components/universal-loader';
import { notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PlaceholderEmpty } from '@/modules/common/components/placeholder-empty';

export const OfferContractsPage = () => {
  const data = useStore($approvedTradesGroups);
  const loadingStatus = useStore($approvedTradesGroupsLoadingStatus);
  const navigate = useNavigate();

  useEffect(() => {
    fetchApprovedTradesGroupsListFx();
  }, []);

  useEffect(() => {
    if (loadingStatus.error) {
      return notification.error({
        message: 'При загрузке данных произошла ошибка. Попробуйте, пожалуйста, позже',
      });
    }
  }, [loadingStatus]);
  return (
    <PageTemplate header="оформленные сделки" customBack="/offer">
      <div className={styles.root}>
        {loadingStatus.loading ? (
          <UniversalLoader />
        ) : (
          <>
            {data && data?.length > 0 ? (
              data.map((item) => (
                <OfferContractItem
                  key={item.company_id}
                  onClick={() => {}}
                  data={item}
                />
              ))
            ) : (
              <PlaceholderEmpty
                title="Вы пока не заключили ни одной сделки"
                label="Для продажи имеющегося на складах зерна, Вы можете воспользоваться интеллектуальным миксованием пшеницы"
                action={{
                  text: 'продать зерно',
                  action: () => navigate('/mixing/recipes-new'),
                }}
              />
            )}
          </>
        )}
      </div>
    </PageTemplate>
  );
};
